import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RootState } from 'store';

import { approveOrReproveTravel, getRepprovalReasons, getTravelForAdmin } from 'actions/travelApproval';
import useUserAccount from 'hooks/useUserAccount';
import { RepprovalReason } from 'models/repprovalReason';
import Dashboard from 'screens/components/Dashboard';

const DashboardContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useUserAccount();

  const accountResult = useSelector((state: RootState) => state.user.accountResult);
  const pendingTravels = useSelector((state: RootState) => state.pendingTravels.travelsAwaitingResult);
  const isLoading = useSelector((state: RootState) => state.pendingTravels.isLoading);
  const [repprovalReasons, setRepprovalReasons] = useState<RepprovalReason[]>();

  const getTravels = useCallback(() => dispatch<any>(getTravelForAdmin()), [dispatch]);

  const getReasons = async () => {
    const response = await getRepprovalReasons();

    if (response) {
      setRepprovalReasons(response.data);
    }
  };

  useEffect(() => {
    getTravels();
  }, [getTravels]);

  if (user?.type !== 'admin' && !user?.isGroupApprover && history.location.pathname === '/dashboard') {
    history.replace('/booking');
    return null;
  }

  useEffect(() => {
    getReasons();
  }, []);

  return (
    <Dashboard
      accountResult={accountResult}
      getTravels={getTravels}
      changeStatus={(travelId: string, isApproval: boolean, approverId: string, reason?: RepprovalReason) =>
        approveOrReproveTravel(travelId, isApproval, approverId, reason)
      }
      pendingTravels={pendingTravels?.data}
      isLoading={isLoading}
      reasons={repprovalReasons ?? []}
    />
  );
};

export default DashboardContainer;
